// Tipos do módulo CRM (espelham as tabelas crm_* do Supabase).

export type CrmCanalTipo = "bot" | "humano";

export type CrmEstagio =
  | "novo"
  | "aguardando_resposta"
  | "ia_atendendo"
  | "humano_atendendo"
  | "renovacao_andamento"
  | "fechado_ganho"
  | "fechado_perdido"
  | "sem_interesse";

export type CrmOrigem =
  | "inbound_bot"
  | "handoff_bot"
  | "inbound_humano"
  | "campanha_marketing"
  | "campanha_renovacao";

export type CrmDirecao = "in" | "out";

export type CrmAutor = "ia" | "operador" | "sistema" | "cliente";

export type CrmStatusEnvio =
  | "pendente"
  | "processando"
  | "enviado"
  | "entregue"
  | "lido"
  | "erro";

export interface CrmCanal {
  id: string;
  nome: string;
  numero: string;
  instancia_evolution: string | null;
  tipo: CrmCanalTipo;
  ativo: boolean;
  created_at: string;
  updated_at: string;
}

export interface CrmConversa {
  id: string;
  telefone_cliente: string;
  nome_contato: string | null;
  cliente_id: number | null;
  canal_id: string;
  estagio: CrmEstagio;
  responsavel_id: string | null;
  ia_ativa: boolean;
  origem: CrmOrigem;
  nao_lidas: number;
  ultima_msg_preview: string | null;
  ultima_msg_em: string;
  created_at: string;
  updated_at: string;
}

export interface CrmMensagem {
  id: string;
  conversa_id: string;
  canal_id: string | null;
  direcao: CrmDirecao;
  corpo: string;
  autor: CrmAutor;
  evolution_message_id: string | null;
  status_envio: CrmStatusEnvio;
  enviada_por: string | null;
  created_at: string;
}

export interface CrmCampanha {
  id: string;
  nome: string;
  descricao: string | null;
  tipo: string;
  mensagem_texto: string;
  canal_id: string | null;
  filtros: CrmCampanhaFiltros | null;
  status: string;
  total_destinatarios: number;
  total_enviados: number;
  total_erros: number;
  agendado_para: string | null;
  criado_por: string | null;
  created_at: string;
  updated_at: string;
}

export interface CrmCampanhaFiltros {
  estado?: string | null;
  cidade?: string | null;
  plano_id?: string | null;
  [key: string]: unknown;
}

export const ESTAGIO_LABEL: Record<CrmEstagio, string> = {
  novo: "Novo",
  aguardando_resposta: "Aguardando resposta",
  ia_atendendo: "IA atendendo",
  humano_atendendo: "Humano atendendo",
  renovacao_andamento: "Renovação em andamento",
  fechado_ganho: "Fechado (ganho)",
  fechado_perdido: "Fechado (perdido)",
  sem_interesse: "Sem interesse",
};

/** Cores por estágio (badges Fynix / cinza carvão SunPro) */
export const ESTAGIO_COLOR: Record<CrmEstagio, string> = {
  novo: "bg-[#E8E9EA] text-[#252D30] border-[#C9C9C9]",
  aguardando_resposta: "bg-[#F3F4F6] text-[#374151] border-[#E5E7EB]",
  ia_atendendo: "bg-[#F3F4F6] text-[#252D30] border-[#E5E7EB]",
  humano_atendendo: "bg-[#252D30] text-white border-[#1A2022]",
  renovacao_andamento: "bg-[#C9C9C9] text-[#1F2937] border-[#9CA3AF]",
  fechado_ganho: "bg-[#1A2022] text-white border-[#111827]",
  fechado_perdido: "bg-red-50 text-red-700 border-red-200",
  sem_interesse: "bg-[#F3F4F6] text-[#6B7280] border-[#E5E7EB]",
};

export const ESTAGIOS_FECHADOS: CrmEstagio[] = [
  "fechado_ganho",
  "fechado_perdido",
  "sem_interesse",
];

export const ORIGEM_LABEL: Record<CrmOrigem, string> = {
  inbound_bot: "Entrada (bot)",
  handoff_bot: "Handoff",
  inbound_humano: "Entrada (humano)",
  campanha_marketing: "Campanha",
  campanha_renovacao: "Renovação",
};

export const CAMPANHA_STATUS_LABEL: Record<string, string> = {
  rascunho: "Rascunho",
  agendada: "Agendada",
  em_andamento: "Em andamento",
  concluida: "Concluída",
  cancelada: "Cancelada",
};

export interface CrmCampanhaEnvio {
  id: string;
  campanha_id: string;
  conversa_id: string | null;
  cliente_id: number | null;
  telefone: string;
  nome_contato: string | null;
  status_envio: CrmStatusEnvio;
  evolution_message_id: string | null;
  mensagem_enviada: string | null;
  erro_detalhe: string | null;
  created_at: string;
  updated_at: string;
}

// Colunas do Kanban (ordem de exibição)
export const KANBAN_COLUNAS: CrmEstagio[] = [
  "novo",
  "aguardando_resposta",
  "ia_atendendo",
  "humano_atendendo",
  "renovacao_andamento",
  "fechado_ganho",
  "fechado_perdido",
  "sem_interesse",
];
